import { Button, DatePicker, Form, Select } from "antd";
import { filterOption, requiredField } from "../common/common";
import { useState } from "react";
import axiosInstance from "../common/api";
import { useNavigate } from "react-router";
import DebounceSelect from "../common/DebounceSelect";
import dayjs from "dayjs";
import FormPage from "../common/FormPage";

export const visitTypes = {
  PREVENTIVE: "Preventiva",
  PERIODIC: "Periodica",
  MANSION_CHANGE: "Cambio mansione",
  RETURN_FROM_ABSENCE: "Ritorno da assenza",
  ON_REQUEST: "Su richiesta",
  TERMINATION: "Cessazione",
};

export default function () {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const onFinish = (data) => {
    setLoading(true);
    axiosInstance
      .post("medicalVisit", data)
      .then(() => navigate(-1))
      .finally(() => setLoading(false));
  };

  return (
    <FormPage title="Nuova visita medica" onFinish={onFinish}>
      <Form.Item label="Dipendente" rules={[requiredField]} name="employee">
        <DebounceSelect
          labelInValue={false}
          fetchOptions={(query) =>
            axiosInstance
              .get("employee", { params: { query, pageSize: 99999 } })
              .then(({ data }) => data.data.map((x) => ({ label: x.fullName, value: x.id })))
          }
        />
      </Form.Item>
      <Form.Item label="Tipologia visita" rules={[requiredField]} name="visitType">
        <Select
          options={Object.entries(visitTypes).map(([k, v]) => ({ value: k, label: v }))}
          showSearch
          filterOption={filterOption}
        />
      </Form.Item>
      <Form.Item label="Medico competente" rules={[requiredField]} name="doctor">
        <DebounceSelect
          labelInValue={false}
          fetchOptions={(name) =>
            axiosInstance
              .get("doctor", { params: { name, pageSize: 99999 } })
              .then(({ data }) =>
                data.data.map((x) => ({ label: x.firstName + " " + x.lastName, value: x.id })),
              )
          }
        />
      </Form.Item>
      <Form.Item
        label="Data"
        rules={[requiredField]}
        name="date"
        getValueProps={(value) => ({ value: value && dayjs(value) })}
        normalize={(value) => value && value.format("YYYY-MM-DD")}
      >
        <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item wrapperCol={{ span: 24 }} style={{ textAlign: "end" }}>
        <Button type="primary" htmlType="submit" loading={loading}>
          Salva
        </Button>
      </Form.Item>
    </FormPage>
  );
}
